module.exports = __webpack_public_path__ + "d3fa64228c76050f03e38dc81aab1428.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/pear_tree_funds.png
// module id = 1717
// module chunks = 0